import { useQuery } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import { API_PRECOUPON, API_PRECOUPON_PRODUCT, API_VOUCHER, BACKEND_HOST, getDataFromUrl, getVoucherData, postData } from '../../../api';
import { Modal, ModalBody, ModalHeader, Button, Input, ListGroup, ListGroupItem, Label } from "@/Components/ui";
;
import moment from 'moment';
import { SITE_ID } from '../../../assets/meta/meta';
import { dialogService } from "@/utils/dialogService";
function UserSendModal({ visible, setVisible, defaultType = "coupon", userList = [], onSendSuccess = () => { }, onSendError = () => { }, }) {
    const { data: coupons, isLoading: couponLoading, isError: couponError, error: couponErrorMessage, refetch: couponRefetch, } = useQuery({
        queryKey: ["coupons"],
        queryFn: async () => {
            const response = await getDataFromUrl(`${BACKEND_HOST}/coupon/products/?include_hidden=true`);
            console.log("coupons", response);
            return response;
        },
    });
    const { data: preCoupons, isLoading: preCouponLoading, isError: preCouponError, error: preCouponErrorMessage, refetch: preCouponRefetch, } = useQuery({
        queryKey: ["preCoupons"],
        queryFn: async () => {
            const response = await getDataFromUrl(API_PRECOUPON_PRODUCT);
            console.log("preCoupons", response);
            return response;
        },
    });
    const { data: vouchers, isLoading: voucherLoading, isError: voucherError, error: voucherErrorMessage, refetch: voucherRefetch, } = useQuery({
        queryKey: ["vouchers"],
        queryFn: async () => {
            const response = await getVoucherData();
            console.log("vouchers", response);
            return response;
        },
    });
    const [checkNotiSend, setCheckNotiSend] = React.useState(false);
    const [checkReceiveRequired, setCheckReceiveRequired] = React.useState(false);
    const [selectedCoupon, setSelectedCoupon] = React.useState("");
    const [selectedPreCoupon, setSelectedPreCoupon] = React.useState("");
    const [selectedVoucher, setSelectedVoucher] = React.useState("");
    const [count, setCount] = React.useState(1);
    const [selectedType, setSelectedType] = React.useState(defaultType);
    const typeName = useMemo(() => {
        if (selectedType === "coupon") {
            return "쿠폰";
        }
        else if (selectedType === "voucher") {
            return "교환권";
        }
        else if (selectedType === "precoupon") {
            return "예약권";
        }
        return "쿠폰";
    }, [selectedType]);
    const toggle = () => {
        setVisible(!visible);
    };
    const clearSelectedOptions = () => {
        setSelectedCoupon("");
        setSelectedPreCoupon("");
        setSelectedVoucher("");
        setCount(1);
        setCheckReceiveRequired(false);
        setCheckNotiSend(false);
    };
    const handleSelectedCoupon = (e) => {
        setSelectedCoupon(e.target.value);
        console.log("selectedCoupon", e.target.value);
    };
    const handleSelectedPreCoupon = (e) => {
        setSelectedPreCoupon(e.target.value);
        console.log("selectedPreCoupon", e.target.value);
    };
    const handleSelectedVoucher = (e) => {
        setSelectedVoucher(e.target.value);
        console.log("selectedVoucher", e.target.value);
    };
    // 결정 283: 무료쿠폰(교환권) 보내는 동안 버튼 막기·진행 표시
    const [vSending, setVSending] = React.useState(false);
    const [vStatus, setVStatus] = React.useState("");
    const vErr = (e) => e?.response?.data?.error || e?.response?.data?.message || e?.message || "알 수 없는 오류";
    const sendToCustomers = async () => {
        if (selectedCoupon === "" && selectedPreCoupon === "" && selectedVoucher === "") {
            await dialogService.handleAlert("쿠폰을 선택해주세요.");
            return;
        }
        if (userList.length === 0) {
            await dialogService.handleAlert("회원을 선택해주세요.");
            return;
        }
        if (count === 0) {
            await dialogService.handleAlert("개수를 입력해주세요.");
            return;
        }
        // sendToCustomers API call
        console.log("sendToCustomers", {
            selectedCoupon,
            selectedPreCoupon,
            selectedVoucher,
            count,
            checkNotiSend,
            userList,
        });
        if (selectedType === "coupon") {
            // send coupon
            let _data = {
                coupon: selectedCoupon,
                count: count,
            };
            _data["users"] = userList;
            postData(`${BACKEND_HOST}/coupon/send/`, _data)
                .then((data) => {
                console.log(data);
                if (data.status == "ok") {
                    onSendSuccess("예약권이 성공적으로 발송되었습니다.");
                }
                else {
                    onSendError(`예약권 발송에 실패했습니다.`);
                }
            })
                .catch((e) => {
                console.log(e);
                onSendError(`예약권 발송에 실패했습니다. ${e?.message}`);
            });
        }
        else if (selectedType === "precoupon") {
            // send precoupon
            let _data = {
                users: userList,
                isSendSMS: checkNotiSend,
                hasToReceive: checkReceiveRequired,
                isBatch: false,
            };
            _data["precoupon_id"] = selectedPreCoupon;
            _data["count"] = count;
            postData(`${API_PRECOUPON}/send-coupons/`, _data)
                .then((data) => {
                console.log(data);
                if (data.result == "ok") {
                    onSendSuccess("예약권이 성공적으로 발송되었습니다.");
                }
                else {
                    onSendError(`예약권 발송에 실패했습니다.`);
                }
            })
                .catch((e) => {
                console.log(e);
                onSendError(`예약권 발송에 실패했습니다. ${e?.message}`);
            });
        }
        else if (selectedType === "voucher") {
            if (vSending) return;
            setVSending(true);
            setVStatus(`보내는 중… (${userList.length}명)`);
            try {
                const data = await postData(`${API_VOUCHER}/send/`, { users: userList.map((user) => Number(user)), isSendSMS: checkNotiSend, voucher: Number(selectedVoucher), count });
                if (data.status === "ok") {
                    const msg = `완료 — ${data.sent}명에게 보냈습니다.` + (data.skipped ? ` (10분 안에 이미 받은 ${data.skipped}명은 건너뜀)` : "");
                    setVStatus(msg); onSendSuccess(msg);
                } else { setVStatus(`실패 — ${data.error || "알 수 없는 오류"}`); onSendError(`실패 — ${data.error || "알 수 없는 오류"}`); }
            } catch (e) { setVStatus(`실패 — ${vErr(e)}`); onSendError(`실패 — ${vErr(e)}`); }
            finally { setVSending(false); }
        }
    };
    const sendToAllCustomers = async () => {
        if (selectedCoupon === "" && selectedPreCoupon === "" && selectedVoucher === "") {
            await dialogService.handleAlert("쿠폰을 선택해주세요.");
            return;
        }
        // sendToAllCustomers API call
        console.log("sendToAllCustomers", {
            selectedCoupon,
            selectedPreCoupon,
            selectedVoucher,
            count,
            checkNotiSend,
        });
        if (selectedType === "coupon") {
            // send coupon
            let _data = {
                coupon: selectedCoupon,
                count: count,
                site: SITE_ID,
            };
            postData(`${BACKEND_HOST}/coupon/send/`, _data)
                .then((data) => {
                console.log(data);
                if (data.status == "ok") {
                    onSendSuccess("예약권이 성공적으로 발송되었습니다.");
                }
                else {
                    onSendError(`예약권 발송에 실패했습니다.`);
                }
            })
                .catch((e) => {
                console.log(e);
                onSendError(`예약권 발송에 실패했습니다. ${e?.message}`);
            });
        }
        else if (selectedType === "precoupon") {
            // send precoupon
            let _data = {
                isSendSMS: checkNotiSend,
                hasToReceive: checkReceiveRequired,
                isBatch: true,
            };
            _data["precoupon_id"] = selectedPreCoupon;
            _data["count"] = count;
            postData(`${API_PRECOUPON}/send-coupons/`, _data)
                .then((data) => {
                console.log(data);
                if (data.result == "ok") {
                    onSendSuccess("예약권이 성공적으로 발송되었습니다.");
                }
                else {
                    onSendError(`예약권 발송에 실패했습니다.`);
                }
            })
                .catch((e) => {
                console.log(e);
                onSendError(`예약권 발송에 실패했습니다. ${e?.message}`);
            });
        }
        else if (selectedType === "voucher") {
            if (vSending) return;
            let total = 0;
            try {
                const info = await getDataFromUrl(`${API_VOUCHER}/send-to-all/info/?voucher=${Number(selectedVoucher)}`);
                if (info.running) { onSendError("전체 발송이 처리 중입니다. 끝난 뒤 다시 시도해 주세요."); return; }
                total = info.total_users || 0;
            } catch (e) { onSendError(`실패 — ${vErr(e)}`); return; }
            if (!window.confirm(`회원 ${total.toLocaleString()}명에게 ${count}장씩 보냅니다. 계속?`)) return;
            setVSending(true);
            setVStatus(`보내는 중… ${total.toLocaleString()}명 중 0명`);
            const timer = setInterval(async () => {
                try {
                    const info = await getDataFromUrl(`${API_VOUCHER}/send-to-all/info/?voucher=${Number(selectedVoucher)}`);
                    const pg = info.progress || {};
                    if (pg.total) setVStatus(`보내는 중… ${pg.total.toLocaleString()}명 중 ${(pg.done || 0).toLocaleString()}명`);
                } catch (e) { /* 진행률만 못 받음 */ }
            }, 2000);
            try {
                const data = await postData(`${API_VOUCHER}/send-to-all/`, { isSendSMS: checkNotiSend, voucher: Number(selectedVoucher), count });
                if (data.status === "ok") {
                    const msg = `완료 — ${data.sent.toLocaleString()}명에게 보냈습니다.` + (data.skipped ? ` (10분 안에 이미 받은 ${data.skipped.toLocaleString()}명은 건너뜀)` : "");
                    setVStatus(msg); onSendSuccess(msg); setVisible(false);
                } else { setVStatus(`실패 — ${data.error || "알 수 없는 오류"}`); onSendError(`실패 — ${data.error || "알 수 없는 오류"}`); }
            } catch (e) { setVStatus(`실패 — ${vErr(e)}`); onSendError(`실패 — ${vErr(e)}`); }
            finally { clearInterval(timer); setVSending(false); }
        }
    };
    return (<div>
            <Modal isOpen={visible} onClose={() => {
            toggle();
        }} scrollable={true} variant="dialog" id="exampleModalScrollable">
                <ModalHeader className="modal-title" id="exampleModalScrollableTitle" toggle={() => {
            toggle();
        }}>
                    {`${typeName} 보내기`}
                </ModalHeader>

                <div className="amz-modal-header flex flex-shrink-0 items-center border-b border-border px-[1.5rem] py-[1rem]">
                    <div className="d-flex">
                        {/* selectedType tab */}
                        <Button color="primary" className="me-1" onClick={() => {
            setSelectedType("coupon");
            clearSelectedOptions();
        }} active={selectedType === "coupon"}>
                            쿠폰
                        </Button>
                        <Button color="primary" className="me-1" onClick={() => {
            setSelectedType("precoupon");
            clearSelectedOptions();
        }} active={selectedType === "precoupon"}>
                            예약권
                        </Button>
                        <Button color="primary" className="me-1" onClick={() => {
            setSelectedType("voucher");
            clearSelectedOptions();
        }} active={selectedType === "voucher"}>
                            교환권
                        </Button>
                    </div>
                </div>

                <ModalBody>
                    <div style={{ height: 20 }}></div>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h6 className="fs-15">{`${typeName} 선택`}</h6>
                        <Button onClick={() => {
            if (selectedType === "coupon") {
                couponRefetch();
            }
            else if (selectedType === "precoupon") {
                preCouponRefetch();
            }
            else if (selectedType === "voucher") {
                voucherRefetch();
            }
        }} color="primary" className="me-1">
                            새로고침
                        </Button>
                    </div>
                    <div className="d-flex">
                        <ListGroup style={{ width: "100%" }}>
                            {(selectedType === "coupon") ?
            ((coupons && coupons.length !== 0) ?
                (coupons.map((coupon) => {
                    return (<ListGroupItem tag="label" key={coupon.id}>
                                                <Input className="form-check-input fs-14 mt-0 align-middle me-1" name="exampleRadios" type="radio" value={coupon.id} checked={selectedCoupon.toString() === coupon.id.toString()} onChange={handleSelectedCoupon}/>
                                                {coupon["title"]}
                                            </ListGroupItem>);
                })) :
                <span>No Coupon</span>) : null}

                            {selectedType === "precoupon" ? (preCoupons && preCoupons.length !== 0 ? (preCoupons.map((precoupon) => {
            return (<ListGroupItem tag="label" key={precoupon.id}>
                                                <Input className="form-check-input fs-14 mt-0 align-middle me-1" name="exampleRadios" type="radio" value={precoupon.id} checked={selectedPreCoupon.toString() === precoupon.id.toString()} onChange={handleSelectedPreCoupon}/>
                                                {precoupon["name"]}
                                            </ListGroupItem>);
        })) : (<span>No precoupon</span>)) : null}

                            {selectedType === "voucher" ? (vouchers && vouchers.length !== 0 ? (vouchers.map((voucher) => {
            return (<ListGroupItem tag="label" key={voucher.id}>
                                                <Input disabled={moment(voucher["만료일"]).isBefore(moment().add(-1, "days"))} className="form-check-input fs-14 mt-0 align-middle me-1" name="exampleRadios" type="radio" value={voucher.id} checked={selectedVoucher.toString() === voucher.id.toString()} onChange={handleSelectedVoucher}/>
                                                <span style={moment(voucher["만료일"]).isBefore(moment().add(-1, "days")) ? { color: "grey" } : {}}>
                                                    {voucher["이름"]} (만료일: {voucher["만료일"]})
                                                </span>
                                            </ListGroupItem>);
        })) : (<span>No Voucher</span>)) : null}
                        </ListGroup>
                    </div>

                </ModalBody>


                <div className="amz-modal-footer flex flex-shrink-0 items-center justify-end gap-2 border-t border-border px-[1.5rem] py-[1rem]">
                    <div style={{ width: "100%" }}>
                        <h6 className="fs-15">대상 회원</h6>
                        {userList && userList.length !== 0 ? (<div>
                                {userList.length}명의 회원에게 전송합니다.
                            </div>) : (<div style={{ color: "red" }}>
                                <i className="ri-error-warning-line"></i>
                                <span style={{ marginLeft: 5 }}></span>
                                선택된 회원이 없습니다.
                            </div>)}
                    </div>

                    <div style={{ width: "100%" }}>

                        <Label className="form-input-label" htmlFor="modalproductCountForm">
                            개수
                        </Label>
                        <Input placeholder="개수" value={count} onChange={(e) => setCount(e.target.value < 100 ? e.target.value * 1 : 100)} id="modalproductCountForm"/>

                    </div>

                    <div style={{ width: "100%" }}>
                        {selectedType === "precoupon" ? (<>
                        <Input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="checkReceiveRequired" checked={checkReceiveRequired} onChange={(e) => {
            setCheckReceiveRequired(e.target.checked);
        }}/>
                        <Label className="form-check-label" htmlFor="checkReceiveRequired">
                            사용자 수신 필요
                        </Label>
                        </>) : null}

                        <Input style={{ marginLeft: 15 }} className="form-check-input" type="checkbox" id="checkNotiSend" checked={checkNotiSend} onChange={(e) => {
            setCheckNotiSend(e.target.checked);
        }}/>
                        <Label className="form-check-label" htmlFor="checkNotiSend">
                            알림 문자 전송
                        </Label>
                    </div>
                </div>
                <div className="amz-modal-footer flex flex-shrink-0 items-center justify-end gap-2 border-t border-border px-[1.5rem] py-[1rem]">
                    <div style={{
            position: "absolute",
            left: 20,
        }}>
                        <Button color="danger" disabled={vSending} onClick={() => {
            sendToAllCustomers();
            if (selectedType !== "voucher") setVisible(false);
        }}>
                            {vSending ? "보내는 중…" : "지점전체 일괄전송"}
                        </Button>
                    </div>
                    <Button color="light" onClick={() => {
            clearSelectedOptions();
            setVisible(false);
        }}>
                        Close
                    </Button>
                    {vStatus ? <span className="text-muted small me-2">{vStatus}</span> : null}
                    <Button color="primary" onClick={() => {
            sendToCustomers();
        }} disabled={userList.length === 0 || vSending}>
                        {vSending ? "보내는 중…" : `${typeName} 전송`}
                    </Button>
                </div>

            </Modal>
        </div>);
}
export default UserSendModal;
